module.exports = __webpack_public_path__ + "static/media/bm-zm10.b1791bb6.png";